module.exports = "https://web-assets.ifttt.com/packs/media/docs/litter_robot_email-2c7980e8.png";